import {Component, Input, OnInit} from '@angular/core';
import {EventItem, League, Lookups} from "@model";
import {AbstractComponent} from "@components";

@Component({
    selector: 'app-league-info-tab',
    templateUrl: './league-info-tab.component.html',
    styleUrls: ['./league-info-tab.component.scss'],
    standalone: false
})
export class LeagueInfoTabComponent extends AbstractComponent implements OnInit {
  @Input() currentEventItem: EventItem | undefined;
  @Input({required: true}) league?: League;
  @Input({required:true}) languages: Lookups[] = [];

  mediaVideoHor: string | undefined;
  mediaVideoVert: string | undefined;
  generalInfoExpanded = false;
  rulesExpanded = false;
  scoringExpanded = false;
  socialMediaLinks: { icon: string; url: string }[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.makeLinksEmbeddable();
    this.initSocialMediaLinks();
  }

  toggleGeneral(): void {
    this.generalInfoExpanded = !this.generalInfoExpanded;
  }

  toggleRules(): void {
    this.rulesExpanded = !this.rulesExpanded;
  }

  toggleScoring(): void {
    this.scoringExpanded = !this.scoringExpanded;
  }



  downloadRulesPdf() {

  }

  initSocialMediaLinks(): void {
    const links = this.league?.organiser?.organiserLinks;
    if (!links) return;

    if (links.facebook) this.socialMediaLinks.push({ icon: 'assets/icons/icons-alt/facebook-alt.svg', url: links.facebook });
    if (links.twitter) this.socialMediaLinks.push({ icon: 'assets/icons/icons-alt/twitter.svg', url: links.twitter });
    if (links.youtube) this.socialMediaLinks.push({ icon: 'assets/icons/icons-alt/youtube.svg', url: links.youtube });
  }

  openSocialMedia(url: string): void {
    if (url) window.open(url, '_blank');
  }

  makeLinksEmbeddable() {
    if(this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoHor)){
      this.mediaVideoHor = 'https://www.youtube.com/embed/' + this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoHor);
      this.videoHorLinkIsValid();
    }
    if(this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoVert)){
      this.mediaVideoVert = 'https://www.youtube.com/embed/' + this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoVert);
      this.videoVertLinkIsValid();
    }
  }

  getLabel(){
    return true;
    }

  makeLinkEmbeddable(link: string | undefined): string | undefined {
    const regex1 = /[?&]v=([^&#]*)/;
    const regex2 = /\/shorts\/([^\/?]+)/;
    const match1 = link?.match(regex1);
    const match2 = link?.match(regex2);
    if (match1) {
      return match1 ? match1[1] : undefined;
    }
    if (match2) {
      return match2 ? match2[1] : undefined;
    }
    return undefined;
  }

  videoHorLinkIsValid(): boolean {
    var p: RegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return !!this.mediaVideoHor?.match(p);
  }

  videoVertLinkIsValid(): boolean {
    var p: RegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return !!this.mediaVideoVert?.match(p);
  }
}
